export default {
	TOGGLE: 'AccordionElementToggle',
};
